import { render, staticRenderFns } from "./PanelSettings.vue?vue&type=template&id=563101ec&scoped=true"
import script from "./PanelSettings.vue?vue&type=script&lang=js"
export * from "./PanelSettings.vue?vue&type=script&lang=js"
import style0 from "./PanelSettings.vue?vue&type=style&index=0&id=563101ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563101ec",
  null
  
)

export default component.exports